import { render, staticRenderFns } from "./CustomPay.vue?vue&type=template&id=8409e47e"
import script from "./CustomPay.vue?vue&type=script&lang=js"
export * from "./CustomPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports